import Cookie from 'js-cookie';

import {
  FALL_BACK,
  getAppCookieDomainToClearTokens,
  getCookie,
  getCookieAttrubutes,
  setCookie
} from '../AccountsStorageUtils';

const FORMS_ACCESS_TOKEN_KEY = 'n67h8d7edq';
const FORMS_REFRESH_TOKEN_KEY = 'nsgor39syl';

export function getFormsAccessToken() {
  return getCookie(FORMS_ACCESS_TOKEN_KEY);
}

export function getFormsRefreshToken() {
  return getCookie(FORMS_REFRESH_TOKEN_KEY);
}

export function setFormsAccessTokenToDomain(
  accessToken: string,
  expiryInDays = 30
) {
  setCookie(FORMS_ACCESS_TOKEN_KEY, accessToken, expiryInDays);
}

export function setFormsRefreshTokenToDomain(
  refreshToken: string,
  expiryInDays = 30
) {
  setCookie(FORMS_REFRESH_TOKEN_KEY, refreshToken, expiryInDays);
}

export const clearFormsAccessToken = (domain?: string) => {
  Cookie.remove(FORMS_ACCESS_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${FORMS_ACCESS_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearFormsRefreshAccessToken = (domain?: string) => {
  Cookie.remove(FORMS_REFRESH_TOKEN_KEY, {
    ...getCookieAttrubutes(),
    domain: domain,
    sameSite: 'None'
  });
  Cookie.remove(`${FORMS_REFRESH_TOKEN_KEY}_${FALL_BACK}`, {
    ...getCookieAttrubutes(),
    domain: domain
  });
};

export const clearFormsDomainTokens = () => {
  const appCookieDomain = getAppCookieDomainToClearTokens();
  if (appCookieDomain) {
    clearFormsAccessToken(appCookieDomain);
    clearFormsRefreshAccessToken(appCookieDomain);
  }
};

export const clearAllFormsDomainTokens = () => {
  clearFormsDomainTokens();
  clearFormsAccessToken();
  clearFormsRefreshAccessToken();
};
